
(function () {
  'use strict';

  if (window.matchMedia('(hover: hover)').matches) return;

  document.querySelectorAll('[data-message-grid]').forEach(function (grid) {
    var cards = grid.querySelectorAll('[data-message-card]');

    cards.forEach(function (card) {
      var link = card.querySelector('.message-card__link');
      if (!link) return;

      link.addEventListener('click', function (event) {
        if (!card.classList.contains('is-active-touch')) {
          event.preventDefault();
          cards.forEach(function (c) {
            c.classList.remove('is-active-touch');
          });
          card.classList.add('is-active-touch');
        }
      });
    });
  });
})();